// extracted by mini-css-extract-plugin
export default {"container":"About_container__ePLGO","cardImg":"About_cardImg__AwC9b","content":"About_content__EP8le","deets":"About_deets__O-SsS"};